import { useCallback, useEffect, useState } from "react";

import { getCachedProjects, listProjects } from "../api/projects";
import { useAuth } from "../context/AuthContext";

export function useProjects() {
  const { user } = useAuth();
  const [projects, setProjects] = useState(() => getCachedProjects(user) ?? []);
  const [loading, setLoading] = useState(() => getCachedProjects(user) === null);

  const refresh = useCallback(
    () => listProjects(user, { revalidate: true }),
    [user],
  );

  useEffect(() => {
    if (!user) {
      setProjects([]);
      setLoading(false);
      return;
    }

    const cached = getCachedProjects(user);
    if (cached !== null) {
      setProjects(cached);
      setLoading(false);
      listProjects(user).then(setProjects).catch(() => {});
      return;
    }

    setLoading(true);
    listProjects(user)
      .then((data) => setProjects(data))
      .catch(() => setProjects([]))
      .finally(() => setLoading(false));
  }, [user]);

  return { projects, loading, refresh, setProjects };
}
